import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import MainRouter from "./routes/MainRouter";

const App = () => {
  return (
    <div className="root">
      <Router>
        <MainRouter />
      </Router>
    </div>
  );
};

export default App;
